export default "__VITE_ASSET__37d65c08__"